<template>
  <WrapperDropdown class="Editor-Smiles-Dropdown">
    <template v-slot:header>
      <ScrollerHorizontal>
        <template #default="{ containerRef }">
          <div class="Editor-Smiles-Dropdown__hdr" ref="containerRef">
            <ul class="Editor-Smiles-Dropdown__nav">
              <li
                class="Editor-Smiles-Dropdown__btn"
                v-for="(section, index) in SECTIONS"
                :key="index"
                @click="goToSection(index)"
                :class="{ 'Editor-Smiles-Dropdown__btn--active': activeSection === index }"
              >
                {{ section.mainEmoji }}
              </li>
            </ul>
          </div>
        </template>
      </ScrollerHorizontal>
    </template>

    <div
      class="Editor-Smiles-Dropdown__block"
      v-for="(section, index) in SECTIONS"
      :key="index"
      ref="smileSections"
    >
      <template v-if="activeSection === index">
        <p class="Editor-Smiles-Dropdown__ttl">{{ section.title }}</p>
        <component :is="section.component" @smile="toSendSmile" />
      </template>
    </div>
  </WrapperDropdown>
</template>

<script setup>
  import { ref } from 'vue';
  //------------------------------------------------
  import WrapperDropdown from '@ui/Wrappers/WrapperDropdown/WrapperDropdown.vue';
  import ScrollerHorizontal from '@shared/UI/Scrollers/ScrollerHorizontal/ScrollerHorizontal.vue';
  // Иконки
  import ActivitiesIcons from './blocks/ActivitiesIcons.vue';
  import AnimalsIcons from './blocks/AnimalsIcons.vue';
  import ClothesIcons from './blocks/ClothesIcons.vue';
  import DrinkIcons from './blocks/DrinkIcons.vue';
  import EventIcons from './blocks/EventIcons.vue';
  import GesturesIcons from './blocks/GesturesIcons.vue';
  import FlagsIcons from './blocks/FlagsIcons.vue';
  import FoodIcons from './blocks/FoodIcons.vue';
  import NatureIcons from './blocks/NatureIcons.vue';
  import SymbolsIcons from './blocks/SymbolsIcons.vue';
  import PeopleIcons from './blocks/PeopleIcons.vue';
  import TransportIcons from './blocks/TransportIcons.vue';
  import SmilesIcons from './blocks/SmilesIcons.vue';
  import TravelIcons from './blocks/TravelIcons.vue';
  import ObjectIcons from './blocks/ObjectIcons.vue';
  //------------------------------------------------
  const emit = defineEmits();
  //------------------------------------------------
  const SECTIONS = [
    { title: 'Смайлики', mainEmoji: '😀', component: SmilesIcons },
    { title: 'Жесты', mainEmoji: '🖐️', component: GesturesIcons },
    { title: 'Люди', mainEmoji: '🧑', component: PeopleIcons },
    { title: 'Одежда', mainEmoji: '🥼', component: ClothesIcons },
    { title: 'Животные', mainEmoji: '🐻', component: AnimalsIcons },
    { title: 'Природа', mainEmoji: '🌲', component: NatureIcons },
    { title: 'События', mainEmoji: '🔥', component: EventIcons },
    { title: 'Еда', mainEmoji: '🍊', component: FoodIcons },
    { title: 'Напитки', mainEmoji: '🥤', component: DrinkIcons },
    { title: 'Активности', mainEmoji: '⚽', component: ActivitiesIcons },
    { title: 'Путешествия', mainEmoji: '⛰️', component: TravelIcons },
    { title: 'Транспорт', mainEmoji: '🚖', component: TransportIcons },
    { title: 'Объекты', mainEmoji: '📈', component: ObjectIcons },
    { title: 'Символы', mainEmoji: '💯', component: SymbolsIcons },
    { title: 'Флаги', mainEmoji: '🚩', component: FlagsIcons },
  ];
  //------------------------------------------------
  const activeSection = ref(0);
  const smileSections = ref([]);
  //------------------------------------------------
  // Отправить выбранный смайл
  const toSendSmile = (smile) => emit('smile', smile);
  // Переключение между секциями
  const goToSection = (index) => {
    activeSection.value = index;
  };
</script>

<style lang="scss">
  @import './styles/Editor-Smiles-Dropdown';
</style>